import { render, staticRenderFns } from "./labelAccountLocationBadge.vue?vue&type=template&id=3d02ab1c&"
import script from "./labelAccountLocationBadge.vue?vue&type=script&lang=js&"
export * from "./labelAccountLocationBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports